/**
 * 网络请求相关配置
 */

let NODE_ENV = process.env.NODE_ENV
let baseURL = ''
let trackBaseURL = ''
let trackBaiduURL = ''
let FeVersion = "0686fe9c3312431f80dfeba940901d59f6852e21"
let versionMessage = "0686fe9 - dutongtong, Tue Jun 25 14:30:18 2024 +0800:补充提交"  
let _ENV = "demo"
let productType = "1"

// 生产环境
if (NODE_ENV === 'production') {
  baseURL = 'https://server.xiaoshanyun.com'
  trackBaseURL = 'https://track-server.xiaoshanyun.com'
  trackBaiduURL = '@PROD.TRACKBAIDUURL@'
}

// 开发环境
if (NODE_ENV === 'development') {
  baseURL = 'https://server.xiaoshanyun.com'
  trackBaseURL = '@DEV.TRACKBASEURL@'
  trackBaiduURL = '@DEV.TRACKBAIDUURL@'
}

const auth = {
  username: 'viewshare',
  password: '3tZAoxbQAEG2nyGlvq6fhSuMNp0jN1A5'
}

export {
  baseURL,
  trackBaseURL,
  trackBaiduURL,
  auth,
  versionMessage,
  _ENV,
  FeVersion,
  productType
}